import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { shareLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsShareLink";
import { css } from "styled-components";

shareLinkStyles.wrapper = mergeToNew(shareLinkStyles.wrapper, {
    css: css`
        margin-top: 20px;
        text-align: left;
    `,
});
